import { render } from "./DirectSettlement.vue?vue&type=template&id=2a4ca287"
import script from "./DirectSettlement.vue?vue&type=script&lang=js"
export * from "./DirectSettlement.vue?vue&type=script&lang=js"

import exportComponent from "/app/vue-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__